import _ from 'lodash';
import Auth from '../shared/Auth';
import {
  constants,
  GetPrimaryNode,
  GetVoltageCharts,
} from '../shared/constants';
import Axios from '../utils/axiosClient';

export const session = {
  client: () => {
    return localStorage.getItem('SessionId');
  },
  setClient: (clientId) => {
    localStorage.setItem('SessionId', clientId);
  },
  user: () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('UserInfo'));
      return userInfo || {};
    } catch (err) {
      console.log('Error while parsing the session', err);
      return null;
    }
  },
  setUser: (userInfo) => {
    localStorage.setItem('UserInfo', JSON.stringify(userInfo));
  },
  config: () => {
    return JSON.parse(localStorage.getItem('defaultConfig'));
  },
  setConfig: (config) => {
    localStorage.setItem('defaultConfig', JSON.stringify(config));
  },
  clear: () => localStorage.clear(),
  MAPURL: () => localStorage.getItem('mapURL'),
  setMAPURL: (mapURL) => localStorage.setItem('mapURL', mapURL),
};

export const checkToken = async () => await Auth();

export async function fetchClientHirarchy(clientId, roleId, roleTypeId) {
  const response = await Axios.get(
    `client/clienthirearchybyroleid/${clientId}/${roleId}/${roleTypeId}`
  );
  return response;
}

export async function fetchReportsList(roleId, clientId) {
  const URL =
    roleId !== 0
      ? _.concat('/pfcreport/reportslistbyrole/', roleId, '/', clientId).join(
        ''
      )
      : 'pfcreport/reportslist';
  const response = await Axios.get(URL);
  return response;
}

export async function fetchFrequencyList() {
  const response = await Axios.get('pfcreport/reportfrequencylist');
  return response;
}

export async function fetchReportDetails(reportId) {
  const response = await Axios.get(`pfcreport/reportdetails/${reportId}`);
  return response;
}

export async function fetchReportLimitVoilation(data) {
  const response = await Axios.post('pfcreport/limitviolation', data);
  return response;
}

export async function fetchReportSaidiSaifi(data) {
  const response = await Axios.post('pfcreport/saidisaifi', data);
  return response;
}
export async function fetchReportAlarmlog(data) {
  const response = await Axios.post('report/alarmlog', data);
  return response;
}
export async function fetchReportEquipmentBreakDown(data) {
  const response = await Axios.post('report/equipmentbreakdown', data);
  return response;
}
export async function fetchReportCBoperation(data) {
  const response = await Axios.post('report/cboperationcycle', data);
  return response;
}
export async function fetchReportOilWindTap(data) {
  const response = await Axios.post('report/oilwindtap', data);
  return response;
}
export async function fetchReportADS(data) {
  const response = await Axios.post('/report/ads', data);
  return response;
}

export async function fetchReportCustomizedPQ(data) {
  const response = await Axios.post('pfcreport/getcustomizedpqreport', data);
  return response;
}

export async function fetchReportCustomizedPDS(data) {
  const response = await Axios.post('pfcreport/getcustomizedpdsreport', data);
  return response;
}

export async function fetchReportCircuitBreaker(data) {
  const response = await Axios.post('pfcreport/circuitbreakertrip', data);
  return response;
}

export async function fetchReport24x7operation(data) {
  const response = await Axios.post('pfcreport/user24x7', data);
  return response;
}

export async function fetchReportCurrentDetails(deviceId, status) {
  const response = await Axios.get(
    `report/currentforecast/${deviceId}/${status}`
  );
  return response;
}

export async function fetchReportHighActivityBreaker(data) {
  const response = await Axios.post('pfcreport/highactivitycb', data);
  return response;
}

export async function syncSLDData(assetPointId) {
  const response = await Axios.get(`oggw/gicommand/${assetPointId}`);
  return response;
}

export async function fetchAssetHourlyData(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(
      `report/hourlytransformerdatareportbydate/${params}`
    );
    return response;
  }
  const response = await Axios.get(
    `report/hourlytransformerdatareportdaterange/${params}`
  );
  return response;
}

export async function fetchEnergyLossReport(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(
      `report/subenergylossreportsingledate/${params}`
    );
    return response;
  }
  const response = await Axios.get(
    `report/subenergylossreportdaterange/${params}`
  );
  return response;
}

export async function fetchTransformerLossReport(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(`report/tflossreportsingledate/${params}`);
    return response;
  }
  const response = await Axios.get(`report/tflossreportdaterange/${params}`);
  return response;
}

export async function fetchVoilationsReport(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(
      `report/violationsreportsingledate/${params}`
    );
    return response;
  }
  const response = await Axios.get(
    `report/violationsreportdaterange/${params}`
  );
  return response;
}

export async function fetchSampleData(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(
      `report/gdsdatasingledatebysampletime/${params}`
    );
    return response;
  }
  const response = await Axios.get(
    `report/gdsdatadaterangebysampletime/${params}`
  );
  return response;
}

export async function fetchPeakDemandReport(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(
      `report/peakdemandreportsingledate/${params}`
    );
    return response;
  }
  const response = await Axios.get(
    `report/peakdemandreportdaterange/${params}`
  );
  return response;
}

export async function fetchAnamoliesReport(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(
      `report/anomolyreportsingledate/${params}`
    );
    return response;
  }
  const response = await Axios.get(`report/anomolyreportdaterange/${params}`);
  return response;
}

export async function fetchFaultData(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const response = await Axios.get(`report/faultreportsingledate/${params}`);
    return response;
  }
  const response = await Axios.get(`report/faultreportdaterange/${params}`);
  return response;
}

export async function fetchEEHourlyFeederLog(isTransformer, type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const report = isTransformer
      ? 'hourlytransformerdatareportbydate'
      : 'hourlyfeederdatareport';
    const response = await Axios.get(`report/${report}/${params}`);
    return response;
  }
  const report = isTransformer
    ? 'hourlytransformerdatareportdaterange'
    : 'hourlyfeederdatareportdaterange';
  const response = await Axios.get(`report/${report}/${params}`);
  return response;
}

export async function fetchDailyReport(isTransformer, type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const report = isTransformer
      ? 'dailylogadssingledate'
      : 'dailylogsheetsingledate';
    const response = await Axios.get(`report/${report}/${params}`);
    return response;
  }
  const report = isTransformer
    ? 'dailylogadsdaterange'
    : 'dailylogsheetdaterange';
  const response = await Axios.get(`report/${report}/${params}`);
  return response;
}

export async function fetchReliabilityIndices(data) {
  const response = await Axios.post('report/relibdatabyfrequency', data);
  return response;
}

export const fetchRolesByRoleId = (roleId) =>
  Axios.get(`role/rolesbyroleidinclself/${roleId}`);

export const fetchRolesApiByRole = (type, roleName) => {
  const apiURL = constants.hirarchyAPI[type][roleName];
  return apiURL || constants.hirarchyAP.ClientAdmin;
};

const getAssetValues = (appName) => {
  switch (appName) {
    case constants.core.APPS.ASSET:
      return '/2,5';
    case constants.core.APPS.REPORT_EXPORT:
      return '/1,4,2,5';
    default:
      return '/1,4';
  }
};

export const fetchRolesApiDataByUser = async (type, roleName, id, appName) => {
  const response = await Axios.get(
    `${fetchRolesApiByRole(type, roleName) + id}${
      roleName === 'asset' ? getAssetValues(appName) : ''
    }`
  );
  return response;
};

export const fetchDemandOverTime = async (type, id) => {
  const response = await Axios.get(
    `analytics/getdemandovertimegraph/${type}/${id}`
  );
  return response;
};

export const fetchDemandsData = async (type, id) => {
  const response = await Axios.get(
    `analytics/peakdemandprofiledatabyid/${type}/${id}`
  );
  return response;
};

export const fetchDemandsTableData = async (type, id) => {
  const response = await Axios.get(
    `analytics/getpeakdemandtable/${type}/${id}`
  );
  return response;
};

export const fetchReliabilityScores = async (type, id, yyyymm) => {
  const response = await Axios.get(
    `analytics/getreliabilityscores/${type}/${id}/${yyyymm}`
  );
  return response;
};

export const fetchReliabilityProfile = async (type, id, yyyymm) => {
  const response = await Axios.get(
    `analytics/reliabilityprofile/${type}/${id}/${yyyymm}`
  );
  return response;
};

export const fetchEnergyBudget = async (type, id, interval) => {
  const response = await Axios.get(
    `analytics/energybudget/${type}/${id}/${interval}`
  );
  return response;
};

export const fetchEnergyOverTime = async (type, id) => {
  const response = await Axios.get(`analytics/getenergyovertime/${type}/${id}`);
  return response;
};

export const fetchRealTimeEfficiency = async (type, id) => {
  const response = await Axios.get(
    `analytics/realtimeefficiency/${type}/${id}`
  );
  return response;
};

export const fetchgetAccumulatedLosses = async (type, id) => {
  const response = await Axios.get(
    `analytics/getaccumulatedlosses/${type}/${id}`
  );
  return response;
};

export const fetchgetEfficiencyChange = async (type, id) => {
  const response = await Axios.get(
    `analytics/getefficiencychange/${type}/${id}`
  );
  return response;
};

export const fetchUnits = async (type, id) => {
  const response = await Axios.get(`analytics/measurementunit/${type}/${id}`);
  return response;
};

export const fetchFaultTypesOverTime = async (type, id) => {
  const response = await Axios.get(
    `analytics/faulttypesovertime/${type}/${id}`
  );
  return response;
};

export const fetchAssetData = async (id) => {
  const response = await Axios.get(`assethealth/assetmonitoringdata/${id}`);
  return response;
};

export const fetchLCAppAnalytics = async (id, data) => {
  const response = await Axios.post(
    `https://lcappph3api.orxa.io/opt/optimisebattery/${id}`,
    data
  );
  return response;
};

export const fetchRTUHealth = async (userid, date) => {
  const dateToSend = _.isEmpty(date) || _.isNil(date) ? 0 : date;
  const response = await Axios.get(
    `monitoring/realtimertustatusbydate/${userid}/${dateToSend}`
  );
  return response;
};

export const getPrimaryNode = async (memberId, clientId) => {
  const response = await Axios.get(`${GetPrimaryNode}/${memberId}/${clientId}`);
  return response;
};

export const getReltimeFeederStatus = async (memberId) => {
  const response = await Axios.get(
    `monitoring/realtimefeederonstatusbydate/${memberId}`
  );
  return response;
};

export const getRealTimeRTUCommStatusByDate = async (memberId) => {
  const response = await Axios.get(
    `monitoring/realtimertucommstatusbydate/${memberId}`
  );
  return response;
};

export const getRealTimeFeederOutageStatus = async (memberId, mom) => {
  const response = await Axios.get(
    `monitoring/realtimefeederoutagestatus/${memberId}/${mom}`
  );
  return response;
};

export async function fetchReportRTUHealth(data) {
  const response = await Axios.post('pfcreport/rtuhealth', data);
  return response;
}

export async function fetchSubstationDailylog(type, params) {
  const response = await Axios.get(`report/substationdailylogbydate/${type}/${params}`);
  return response;
}

export async function fetchReportEventLogSoE(type, params) {
  if (_.isEqual(type, constants.core.REPORTS_TYPE.SINGLE_DATE)) {
    const report = 'dailyeventlogsingledate';
    const response = await Axios.get(`report/${report}/${params}`);
    return response;
  }
  const report = 'dailyeventlogdaterange';
  const response = await Axios.get(`report/${report}/${params}`);
  return response;
}

export async function fetchReportForLoadPriorityTable(type, params) {
  const response = await Axios.get(`report/LoadPriorityTable/${type}/${params}`);
  return response;
}

export async function fetchReportForAssetDailyCountData(params) {
  const response = await Axios.get(`report/assetDailyRecordCount/${params}`);
  return response;
}

export async function fetchProductDataStreamInterval(params) {
  const response = await Axios.get(
    `report/getProductDataStreamByInterval/${params}`
  );
  return response;
}

export async function getPrimaryDataByUser(memberId, clientId) {
  const response = await Axios.get(
    `/monitoring/primarydatabyuser/${memberId}/${clientId}`
  );
  return response;
}

export async function fetchHirarchyDetails(type, id) {
  const apiURL = constants.hirarchyAPI.byHirarchy[type];
  const response = await Axios.get(`${apiURL}/${id}`);
  return response;
}

export const levelSelector = (type) => {
  switch (type) {
    case 'client':
      return ['circleId', 'circleName', 'circle', 'clientId', 'client'];
    case 'circle':
      return ['divisionId', 'divName', 'division', 'circleId', 'circle'];
    case 'division':
      return ['townId', 'townName', 'town', 'divisionId', 'division'];
    case 'town':
      return [
        'subDivisionId',
        'subDivisionName',
        'subdivision',
        'townId',
        'town',
      ];
    case 'subdivision':
      return [
        'sectionId',
        'sectionName',
        'section',
        'subDivisionId',
        'subdivision',
      ];
    case 'section':
      return [
        'assetPointId',
        'assetPointName',
        'substation',
        'sectionId',
        'section',
      ];
    case 'substation':
      return ['assetId', 'assetName', 'asset', 'assetPointId', 'substation'];
    case 'asset':
      return ['circleId', 'circleName', 'circle', 'clientId', 'client'];
    default:
      return [];
  }
};

export const HirarchyDataSelector = (type, obj) => {
  const data = levelSelector(type);
  const sessionId = session.client();
  let objToFilter = obj.filter((item) => item.clientId === Number(sessionId));
  if (objToFilter.length === 0) {
    objToFilter = obj;
  }
  return objToFilter.map((item) => ({
    id: item[data[0]],
    name: item[data[1]],
    nodeType: data[2],
    parentId: item[data[3]],
    parentType: data[4],
  }));
};

// replace with actual apinetwork status
export async function getNetworkStatus() {
  const response = await Axios.get(`/iecgw/gethoststate`);
  return response;
}

export const uploadFileToServer = async (data) => {
  const response = await Axios.post(
    `https://lcappph3api.orxa.io/opt/upload`,
    data,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response;
};

export const getRTUCommListByCircle = async (
  memberId,
  circleId,
  isCommunicating
) => {
  const response = await Axios.get(
    `/monitoring/getrtucommlistbycircleid/${memberId}/${circleId}/${isCommunicating}`
  );
  return response;
};

export const getFeederCommListByCircle = async (
  memberId,
  circleId,
  isCommunicating
) => {
  const response = await Axios.get(
    `/monitoring/getfeedercommlistbycircleid/${memberId}/${circleId}/${isCommunicating}`
  );
  return response;
};

export const fetchReliabilityScoresYearly = async (type, id) => {
  const response = await Axios.get(
    `analytics/getreliabilityscoresyearly/${type}/${id}`
  );
  return response;
};

export const getCircleByUser = async (circleId) => {
  const response = await Axios.get(`circle/circlesbyclient/${circleId}`);
  return response;
};

export const getDivisionByCircleId = async (circleId) => {
  const response = await Axios.get(`division/divisionsbycircle/${circleId}`);
  return response;
};

export const getDemandVsTimeById = async (assetId, size) => {
  if (checkToken())
    return await Axios.get(
      `analytics/peakdemandforecastvsactual/asset/${assetId}/${size}`
    );
};

export const getClientConfiguration = async () => {
  return await Axios.get(`client/clientconfiguration/${session.client()}`);
};

export const getPageAccessByRole = async () => {
  const { roleId } = session.user();
  return await Axios.get(`role/rolepages/${roleId}`);
};

export const validateCredentialsForDO = async (email, password) => {
  const data = {
    Email: email,
    Password: password,
  };

  return await Axios.post('/sld/validatecredentialsfordocontrol', data);
};
// ********************** Chart **********************
export const getVoltageForecastData = (deviceId, status) => {
  return Axios.get(`${GetVoltageCharts}${deviceId}/${status}`);
};
